import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useNoteTypes(userID) {
  const { data, _error, isLoading, isValidating, mutate } = useSWR(
    userID ? `/notetypes/` : null,
    (url) => fetcher(url),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );

  return {
    noteTypes: data,
    isLoading: isLoading,
    isValidating: isValidating,
    mutate: mutate,
  };
}

export default useNoteTypes;
